import { useTranslation } from 'react-i18next';
import classes from './Banner.module.scss';
import image from '../../../assets/img/Gallery/banner.webp';

const Banner = () => {
    const { t } = useTranslation();
    return (
        <section className="container">
            <div className={classes.wrap}>
                <div className={classes.head}>
                    <h1 className={`${classes.title} font-48`}>
                        {t('gallery.banner.title')}
                    </h1>
                </div>
                <p className={`${classes.text} font-16`}>
                    {t('gallery.banner.text')}
                </p>
                <img className={classes.image} src={image} alt='' />
            </div>
        </section>
    );
};

export default Banner;
